import React from 'react';
import { format, parseISO, setYear } from 'date-fns';
import { CakeIcon } from 'lucide-react';
import { useHRStore } from '../../hooks/useHRStore';
import type { Navigate } from '../../types/hr';
import { displayName } from '../../utils/employees';
import { TODAY } from '../../utils/format';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { Card } from '../ui/Card';
import { EmptyState } from '../ui/EmptyState';
export function BirthdaysCard({
  onNavigate
}: {
  onNavigate: Navigate;
}) {
  const {
    employees
  } = useHRStore();
  const list = employees.filter(e => e.status !== 'Terminated' && parseISO(e.birthDate).getMonth() === TODAY.getMonth()).map(e => ({
    employee: e,
    date: setYear(parseISO(e.birthDate), TODAY.getFullYear())
  })).sort((a, b) => a.date.getTime() - b.date.getTime());
  return <Card title="Birthdays this month" subtitle={`${list.length} in ${format(TODAY, 'MMMM')} · ages hidden`} icon={CakeIcon} bodyClassName="px-3 pb-3" data-id="element-25" data-mp="64pz6qihmoab">
      {list.length === 0 ? <div className="px-3 pb-3" data-id="element-26" data-mp="ncinthb5xcy6">
          <EmptyState icon={CakeIcon} title="No birthdays this month" compact data-id="element-27" data-mp="ifigl32ku45h" />
        </div> : <ul className="space-y-0.5" data-id="element-28" data-mp="x3vei5l85x2m">
          {list.map(({
        employee,
        date
      }) => {
        const isToday = format(date, 'MM-dd') === format(TODAY, 'MM-dd');
        const past = date < TODAY && !isToday;
        return <li key={employee.id} data-id="element-29" data-mp="4g92c8xxlk45">
                <button type="button" onClick={() => onNavigate({
            page: 'profile',
            employeeId: employee.id
          })} className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition hover:bg-canvas/70 ${past ? 'opacity-60' : ''}`} data-id="element-30" data-mp="4han554r1kz2">
                  <Avatar name={displayName(employee)} seed={employee.id} size="sm" data-id="element-31" data-mp="1psk9dmvot65x" />
                  <span className="min-w-0 flex-1" data-id="element-32" data-mp="1ktprqo9ghnne">
                    <span className="block truncate text-sm font-medium text-navy" data-id="element-33" data-mp="1ksxuza44hjvj">{displayName(employee)}</span>
                    <span className="block truncate text-xs text-muted" data-id="element-34" data-mp="1rwnw3hsrasiz">{employee.department}</span>
                  </span>
                  {isToday ? <Badge tone="orange" data-id="element-35" data-mp="21v3m1hg1rvqw">Today</Badge> : <span className="text-xs text-muted" data-id="element-36" data-mp="21w4zttog6wcb">{format(date, 'MMM d')}</span>}
                </button>
              </li>;
      })}
        </ul>}
    </Card>;
}